<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  lkPath: {
    type: String,
    default: '',
  },
  primaryTitle: {
    type: String,
    default: 'клуб ветеринарных<br> специалистов',
  },
  primaryHref: {
    type: String,
    default: '',
  },
  primaryIcon: {
    type: String,
    default: '/modules/custom/proplan_events/app/assets/img/club.svg',
  },
  primaryLinkText: {
    type: String,
    default: 'Присоединиться',
  },
  articlesHref: {
    type: String,
    default: '/vet/publications',
  },
  articlesIcon: {
    type: String,
    default: '/modules/custom/proplan_events/app/assets/img/articles.svg',
  },
  analyticsEventName: {
    type: String,
    default: 'VetEvents_join_button',
  },
})

const resolvedPrimaryHref = computed(() => props.primaryHref || props.lkPath)

const sendEvent = () => {
  dataLayer.push({
    'event': 'DLevent',
    'eventName': props.analyticsEventName,
    'ParameterName1': 'click',
    'ParameterValue1': 'click'
  });
}
</script>
<template>
  <div class="events-interesting__items">
    <div class="events-interesting__item">
      <img :src="primaryIcon" alt="">
      <div>
        <h3 v-html="primaryTitle"></h3>
        <a :href="resolvedPrimaryHref" @click="sendEvent">{{ primaryLinkText }}</a>
      </div>
    </div>
    <div class="events-interesting__item">
      <img :src="articlesIcon" alt="">
      <div>
        <h3>Статьи</h3>
        <a :href="articlesHref">Подробнее</a>
      </div>
    </div>
  </div>
</template>
